import axios from "axios";

const endpoint_url = "/campaignV2/customer/instantLuckyDraw/prizes";

const getAllPrize = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          instantLuckyDrawId: parameters.instantLuckyDrawId,
          isWinnerShow: parameters.isWinnerShow,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAllPrize;
